import { render } from "./Breadcrumbs.vue?vue&type=template&id=a2ecb536&scoped=true&ts=true"
import script from "./Breadcrumbs.ts?vue&type=script&lang=ts&external"
export * from "./Breadcrumbs.ts?vue&type=script&lang=ts&external"

import "./Breadcrumbs.scss?vue&type=style&index=0&id=a2ecb536&lang=scss&scoped=true&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2ecb536"]])

export default __exports__